module.exports = __webpack_public_path__ + "static/media/feat-barons-img3.496dd7ed.jpg";